import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';
import Icon from '../../Icon';
import LoadingAnimation from '../BateryChargeAnimation';

export default function Button({
  label = '',
  onClick = () => null,
  type = 'button',
  className = '',
  disabled = false,
  children = null,
  hide = false,
  iconName = '',
  isLoading = false,
  ...props
}) {
  if (!!hide) {
    return null;
  }
  return (
    <button
      className={`button ${className}`}
      disabled={disabled}
      type={type}
      onClick={onClick}
      {...props}>
      {iconName ? <Icon iconName={iconName} /> : null}
      {isLoading ? <LoadingAnimation /> : children || label}
    </button>
  );
}

Button.propTypes = {
  label: PropTypes.string,
  onClick: PropTypes.func,
  type: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  children: PropTypes.any,
  iconName: PropTypes.string
};
